import invariant from 'invariant';
import { createUrl } from '../helpers/createUrl';
import { getPathnameFromHref } from '../helpers/getPathnameFromHref';
import type { ValidHref } from '../types';
// @todo (WEB-1045): Add condensed UUID support to routes
// import { toCondensedUUID } from '@frameio/utils/formatters/uuid';

// @todo (WEB-1045): Remove when condensed UUID support is added to routes
const toCondensedUUID = (uuid: string): string => uuid;

export type C2CConnectionsGetLinkParams =
  /**
   * C2C Connections Page
   * /project/:projectId/c2c-connections(/:deviceLinkId)
   */
  {
    page: 'c2cConnections';
    projectId: string;
    deviceLinkId?: string;
    lightroomConnectRedirect?: boolean;
  };

export const getLinkForC2CConnections = (
  params: C2CConnectionsGetLinkParams
): ValidHref => {
  const { projectId, deviceLinkId, lightroomConnectRedirect } = params;

  // Assert required params for better error messages
  invariant(projectId, 'projectId is required');

  // /project/:projectId/c2c-connections(/:deviceLinkId)
  const _projectId = toCondensedUUID(projectId);
  const _deviceLinkId = toCondensedUUID(deviceLinkId);
  return createUrl({
    pathname: `/project/${_projectId}/c2c-connections${
      deviceLinkId ? `/${_deviceLinkId}` : ''
    }`,
    searchParams: lightroomConnectRedirect
      ? { redirect: 'lightroomConnect' }
      : undefined,
  });
};

export const isC2CConnectionsPageType = (href: ValidHref): boolean => {
  const pathname = getPathnameFromHref(href);
  const parts = pathname.split('/');
  return (
    parts.length <= 5 &&
    parts[1] === 'project' &&
    parts[3] === 'c2c-connections'
  );
};
